import React, { useState, useContext } from "react";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import instance from "../../utils/customInstance";
import Bread from "../../common/Bread";
import contactSVG from "../../assets/contactSVG.svg";
import { ClipLoader } from "react-spinners";
import "./grievanceResForm.scss";
import { LangContext } from "../../context/LangContext";

const GrievanceResForm = () => {
  const { state } = useContext(LangContext);
  const isNepali = state?.np;

  const breadcrumList = {
    image: "",
    link: "",
    title: isNepali ? "गुनासो प्रतिक्रिया" : "Grievance Response",
    l1: isNepali ? "गृहपृष्ठ" : "Home",
    l2: isNepali ? "गुनासो प्रतिक्रिया" : "Grievance Response",
    l3: "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState(null);
  const [isReadMore, setIsReadMore] = useState(true);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const { data } = await instance.post("grievance/check", values);

      if (data?.error) {
        toast.error(data.error);
      } else if (data?.status_code === 307) {
        toast.error(
          isNepali
            ? "इमेल वा सबमिसन कोड मिलेन"
            : "Email or Submission Code does not match",
        );
      } else if (data?.status_code === 200) {
        setResData(data);
        toast.success(
          isNepali ? "सबमिसन कोड प्रमाणित भयो" : "Submission Code Verified",
        );
      }
    } catch (err) {
      toast.error(
        isNepali
          ? "पठाउन असफल भयो। पुनः प्रयास गर्नुहोस्।"
          : "Failed to send. Please try again.",
      );
    }
    setLoading(false);
  };

  return (
    <div>
      <Bread data={breadcrumList}>
        {resData?.status_code === 200 ? (
          <div className="grievanceFormResponseAnsMainContainer">
            <h4 className="grievanceFormResHead">
              {isNepali ? "नमस्ते," : "Hello,"} {resData?.grevience.name}
            </h4>

            <p className="grievanceFormResSubHead">
              {isNepali ? "तपाईंले" : "The issue you posted on"}{" "}
              {resData.grevience.created}{" "}
              {resData.grevience.status === "0" ? (
                <span>
                  {isNepali
                    ? "मा पेश गर्नुभएको गुनासो प्रक्रियामा छ। कृपया पछि पुनः जाँच गर्नुहोस्।"
                    : "is under process. Please check again later."}
                </span>
              ) : (
                <span>
                  {isNepali
                    ? "मा पेश गर्नुभएको गुनासोको जवाफ दिइसकिएको छ।"
                    : "is already answered."}
                </span>
              )}
            </p>

            <h5 className="grievanceFormResIssue">
              {isNepali ? "समस्या :" : "Issue :"}
            </h5>

            <p className="grievanceFormResIssueSubject">
              {resData.grevience.subject}
            </p>

            <p className="grievanceFormResIssueText">
              {isReadMore
                ? resData.grevience.issue.slice(0, 400)
                : resData.grevience.issue}
              {resData.grevience.issue.length > 400 && (
                <span onClick={toggleReadMore} className="read-or-hide">
                  {isReadMore
                    ? isNepali
                      ? " ... थप पढ्नुहोस्"
                      : "... read more"
                    : isNepali
                      ? " कम देखाउनुहोस्"
                      : " show less"}
                </span>
              )}
            </p>

            {resData.grevience.issue_reply !== null && (
              <h5 className="grievanceFormResIssue">
                {isNepali ? "जवाफ :" : "Answer :"}
              </h5>
            )}

            <p
              className="grievanceFormResIssueAns"
              dangerouslySetInnerHTML={{
                __html: resData.grevience.issue_reply,
              }}
            ></p>
          </div>
        ) : (
          <div className="grievanceFormMainContainer">
            <img
              className="grievanceFormImage"
              src={contactSVG}
              alt="contact svg"
            />

            <div className="grievancePageFormContainer">
              <h3>
                {isNepali
                  ? "आफ्नो नतिजा जाँच गर्नुहोस्।"
                  : "Check your result."}
              </h3>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grievanceFormInputContainer">
                  <label>{isNepali ? "इमेल ठेगाना" : "Email Address"}</label>
                  <input
                    type="text"
                    placeholder={isNepali ? "इमेल ठेगाना" : "Email Address"}
                    {...register("email", {
                      required: isNepali
                        ? "इमेल आवश्यक छ"
                        : "Email is Required",
                    })}
                  />
                  <span>{errors.email?.message}</span>
                </div>

                <div className="grievanceFormInputContainer">
                  <label>{isNepali ? "सबमिसन कोड" : "Submission Code"}</label>
                  <input
                    type="text"
                    placeholder={isNepali ? "सबमिसन कोड" : "Submission Code"}
                    {...register("user_code", {
                      required: isNepali
                        ? "सबमिसन कोड आवश्यक छ"
                        : "Submission Code is Required",
                    })}
                  />
                  <span>{errors.user_code?.message}</span>
                </div>

                <button
                  className="grievanceFormResetButton grievanceSubmitButton"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {loading && <ClipLoader size={20} color="#fff" />}
                  {isNepali ? "जाँच गर्नुहोस्" : "Check"}
                </button>
              </form>
            </div>
          </div>
        )}
      </Bread>
    </div>
  );
};

export default GrievanceResForm;
